import { AlloyIcon } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { LineAttributeItem, isIndirectReplacement } from '../utils';
import {
  cartItemPropType,
  replacementPartsPropType
} from '../declarations.propTypes';
import styles from './styles.modules.scss';
import UnitPriceTableCell from '../../common/UnitPriceTableCell';
import { getAvailability } from '../../common/commonUtils';

const ReplacementPartsMobileView = ({
  currency,
  item,
  replacementParts,
  availabilityToggle,
  hoseAvailabilityLabel
}) => {
  const [t] = useTranslation();
  const isStoreAvailabilityEnabled = useSelector(
    s => s.dealer?.isStoreAvailabilityEnabled
  );
  const currentReplacements = replacementParts?.map(element => {
    const isReman = element.partLevelFlags.isReman;
    return (
      <>
        <hr className={`${styles['hr-margin']}`} />
        <div
          className={`d-flex flex-column row ms-0 ps-2`}
          key={`${element?.id}-${element?.item}`}
        >
          <p className="text-univers u-color--ExtraDarkGray u-fs--16 mb-2">
            {`${element.partNumber}: ${element.partName}`}
          </p>
          <p className="u-color--DarkGray mb-2">
            {`${t('QUANTITY')} ${element.quantity}`}
          </p>
          {!isIndirectReplacement(element?.availability) ? (
            <>
              <p className="d-flex flex-column u-fs--16 u-color--ExtraDarkGray mt-1 mb-2">
                <UnitPriceTableCell
                  unitPrice={element.price?.formatted?.unitPrice}
                  coreCharges={element.price?.formatted?.coreCharges}
                  showCoreCharges={!!element.price?.unformatted?.coreCharges}
                  currency={currency}
                />
              </p>
              {getAvailability(
                element,
                isStoreAvailabilityEnabled,
                hoseAvailabilityLabel,
                availabilityToggle
              )}
            </>
          ) : null}
          {isIndirectReplacement(element?.availability) ? (
            <div className="mt-1 u-fs--12 u-color--DarkRed">
              {t('INDIRECT_REPLACEMENT_ERROR_MESSAGE')}
            </div>
          ) : null}
          {isReman && (
            <p className="d-flex flex-column u-fs--16 u-color--ExtraDarkGray mt-1 mb-0">
              <LineAttributeItem
                icon="icon-remanufactured"
                title={t('REMANUFACTURED_PART')}
              />
            </p>
          )}
        </div>
      </>
    );
  });
  return (
    <div>
      <div className={`d-flex flex-column row ms-n2`}>
        <p className="text-univers u-color--ExtraDarkGray u-fs--16 mb-1">
          {`${item.partNumber}: ${item.partName}`}
        </p>
        <p className="u-color--DarkGray mb-1">
          {t('QUANTITY')} {item.quantity}
        </p>
        <div className="d-flex flex-row u-color--DarkGray">
          {t('AVAILABILITY')}:
          <div className="d-flex flex-row ms-1">
            <AlloyIcon
              height={15}
              width={15}
              fill="#E56C00"
              icon="icon-warning"
            />
          </div>
          <div className="me-3">
            <p className="u-color--DarkGray flex-wrap mb-0">
              {t('REPLACEMENT_PARTS_MODAL_REPLACEMENT_AVAILABILITY')}
            </p>
          </div>
        </div>
      </div>
      {replacementParts?.length >= 1 ? currentReplacements : null}
    </div>
  );
};

ReplacementPartsMobileView.propTypes = {
  currency: PropTypes.string,
  availabilityToggle: PropTypes.bool,
  item: cartItemPropType,
  replacementParts: replacementPartsPropType,
  hoseAvailabilityLabel: PropTypes.string
};
export default ReplacementPartsMobileView;
